"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Component = function () { return (react_1.default.createElement("svg", { width: "14", height: "10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.225 7.104L12.329 0l1.414 1.414-8.518 8.519L0 4.708l1.414-1.414 3.81 3.81z", fill: "#1F1F1F" }))); };
exports.default = Component;
//# sourceMappingURL=Checkmark.js.map